import type { TypographyProps } from "@mui/material";
import { Typography } from "@mui/material";
import "flag-icons/css/flag-icons.min.css";

interface Props {
  countryCodeAlpha2: string;
  typographyProps?: TypographyProps;
}

const CountryFlag = ({ countryCodeAlpha2, typographyProps = {} }: Props) => (
  <Typography
    component="span"
    {...typographyProps}
    className={`fi fi-${countryCodeAlpha2.toLowerCase()}`}
    sx={[
      { width: 20, height: "auto" },
      ...(Array.isArray(typographyProps.sx) ? typographyProps.sx : [typographyProps.sx]),
    ]}
  />
);

export default CountryFlag;
